module.exports = __webpack_public_path__ + "static/img/down_img04.png.f9d9cb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sptj/down_img04.png.png
// module id = TJD1
// module chunks = 1